import './MetricsField.css';

import { Col, Container, Row } from 'react-bootstrap';
import React, { Fragment, useState } from 'react';
import { getModelName } from '../../services/utils';
import Text from '@amzn/meridian/text';

import spinner from '../../../../static/spinner.gif';

import Expander from '@amzn/meridian/expander';
const ControlledExpander = props => {
  const [open, setOpen] = useState();
  return <Expander open={open} onChange={setOpen} {...props} />;
};

const MetricsField = data => {
  const [show, setShow] = useState(true);
  const translatedSegmentTooltipMessage =
    'Information is not available because there is a mismatch between segmentation of the source text and translated text (i.e the number of segments is different). You can reproduce the translation for the segment by using the debug tool below, but be aware that the translation may be different from the original translation.';
  const additionalRTSSegmentsTooltipMessage = count =>
    `RTS stored ${count} additional segment(s) compared to what was segmented from original transcript message. This could be because of an empty newline character or other reasons. The segments are displayed with best available information.`;
  const additionalSourceSegmentsTooltipMessage = count =>
    `RTS did not store ${count} segment(s) that are present in original transcript message. The segments are displayed with best available information.`;

  const flipState = () => {
    setShow(!show);
  };

  if (!data?.data?.messages && !data?.error && !data?.isLoading) {
    return null;
  }

  if (!data?.data?.messages && !data?.error && data?.isLoading) {
    return (
      <Container className="mb-1">
        <h5>
          <b>{data.title}</b>
        </h5>
        <img src={spinner} alt="Loading..." className="App-spinner" />
      </Container>
    );
  }

  const messages = data?.data?.messages;
  return data.error ? (
    <Container className="mb-1">
      <h5>
        <b>{data.title}</b>
      </h5>{' '}
      {data.isTreatErrorAsInfo ? (
        <b className="color-dark-yellow">{data.error}</b>
      ) : (
        <b className="color-red">{data.error}</b>
      )}
    </Container>
  ) : (
    <Container className="mb-1">
      <h5 className="cursor-pointer" onClick={flipState}>
        <b>{data.title + (show ? ' (Hide) ' : '( Show )')}</b>
      </h5>
      {show && (
        <Row className="border-radius-5">
          <Col className="border-radius-5">
            <table className="table table-striped message-table">
              <tbody>
                {messages.map((value, index) => {
                  const meta = value?.metadata;
                  const segments = value?.segments;
                  const sourceText = value?.sourceText;
                  const translatedText = value?.translatedText;
                  return (
                    <Fragment key={index}>
                      <tr>
                        <td colspan="2">
                          <b className="color-blue">
                            Source Text({meta?.messageAuthor})({meta?.sourceLocale})
                          </b>
                          : {sourceText}
                          <ControlledExpander title="Additional Information" type="inline">
                            <Text>tenantId: {meta?.tenantId}</Text>
                            <Text>workflowId: {meta?.workflowId}</Text>
                          </ControlledExpander>
                        </td>
                      </tr>
                      {segments?.map((value, idx) => {
                        return (
                          <Fragment key={idx}>
                            <tr className="small-font">
                              <td className="segment-field">
                                <b>Segment{idx + 1}</b>
                              </td>
                              <td>:&nbsp;{value?.sourceText}&nbsp;</td>
                            </tr>
                            <tr className="small-font">
                              <td className="segment-field">
                                <b className="color-green">Translated{idx + 1}</b>
                              </td>
                              <td>
                                :&nbsp;
                                {value?.translatedText ? (
                                  value?.translatedText
                                ) : (
                                  <span
                                    className="segment-warning-message"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={translatedSegmentTooltipMessage}
                                  >
                                    <i className={'d-inline icon-warning'}>{'    '}</i>
                                    {'Info Not Available'}{' '}
                                  </span>
                                )}{' '}
                                &nbsp;
                                <span className="badge badge-secondary">{value?.matchType}</span>
                                &nbsp;
                                <span className="badge badge-info">
                                  {getModelName(
                                    value?.matchType,
                                    meta?.modelName,
                                    meta?.translationEngine,
                                    meta?.llmModelId
                                  )}
                                </span>
                                {value?.matchType?.toUpperCase() === 'LLM' && meta?.llmPromptId && (
                                  <>
                                    &nbsp;
                                    <span className="badge badge-tertiary">{meta.llmPromptId}</span>
                                  </>
                                )}
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })}
                      {value?.mismatchedSourceSegmentCount !== 0 ? (
                        <tr className="small-font">
                          <td></td>
                          <td>
                            <span
                              className="segment-warning-message"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={
                                value?.mismatchedSourceSegmentCount > 0
                                  ? additionalSourceSegmentsTooltipMessage(value?.mismatchedSourceSegmentCount)
                                  : additionalRTSSegmentsTooltipMessage(Math.abs(value?.mismatchedSourceSegmentCount))
                              }
                            >
                              <i className={'d-inline icon-warning'}>{'    '}</i>
                              {'Source Segments Count Mismatch'}
                            </span>
                          </td>
                        </tr>
                      ) : null}
                      <tr className="table-row-bottom-border">
                        <td colSpan="2">
                          <b className="color-orange">Translated Text({meta?.targetLocale})</b>: {translatedText}
                        </td>
                      </tr>
                      <div>
                        <br />
                      </div>
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default MetricsField;
